<div class="person-link-directive"
     (mouseenter)="popoverInitialised = true"
     #dashboardLink>
    @if (profileUrl$ | async; as profileUrl) {
        <a [routerLink]="profileUrl"
           [title]="!showPopover ? (person$ | async)?.fullName : ''"
           [ngClass]="{ 'person-link-nowrap': preventWrap }">
            <ng-container *ngTemplateOutlet="linkContentsTemplate"></ng-container>
        </a>
        <!-- Popover only shown if you have permission to see public profile data, i.e. profileUrl is defined -->
        @if (showPopover && popoverInitialised && (person$ | async)) {
            <dx-popover [target]="dashboardLink"
                        showEvent="dxpointerenter"
                        [hideEvent]="{ name: 'dxpointerleave', delay: 300 }"
                        [(visible)]="popoverVisible"
                        [minWidth]="300"
                        [position]="popoverPosition"
                        (onContentReady)="onPopoverContentReady($event)"
                        (onShowing)="popoverCancelHiding = false"
                        (onHiding)="onPopoverHiding($event)">
                <adapt-link-person-contents [person]="person$ | async"></adapt-link-person-contents>
            </dx-popover>
        }
    } @else {
        <div [ngClass]="{ 'person-nowrap': preventWrap }">
            <ng-container *ngTemplateOutlet="linkContentsTemplate"></ng-container>
        </div>
    }

    <ng-template #linkContentsTemplate>
        @if (showImage) {
            <adapt-person-image class="person-link-person-image"
                                [person]="person$ | async"
                                [imageSize]="imageSize"
                                containerClass="person-link-image lh-base"
                                [disabled]="(isActiveNow$ | async) === false"></adapt-person-image>
        }

        @if (showText) {
            <div class="person-link-text">
                @if (person$ | async; as person) {
                    <p>
                        {{ person.fullName }}
                        @if (personActiveText$ | async; as text) {
                            <small>({{ text }})</small>
                        }
                    </p>
                } @else {
                    {{ nullValueText }}
                }
            </div>
        }
    </ng-template>
</div>
